import { AppLocale } from 'utils/parseAnyLocale';
import { gbLabelGenerators } from '../en-GB';
import { CsProductCardsProduct, CsProductCardsProductLabel } from 'components/ProductCards/types';
import { defaultLabelGenerators } from '../default';
import { Product } from 'api/dbs/models';

export const getProductLabels = (locale: AppLocale) => {
  const generators = locale === 'en-GB' ? gbLabelGenerators : defaultLabelGenerators;
  return (product: Product, productCardsProduct?: CsProductCardsProduct) =>
    generators
      .map((fn) => fn(product, productCardsProduct))
      .filter(Boolean)
      .splice(0, 2) as CsProductCardsProductLabel[];
};
